export * from '../../../../shared/src/rules/talents';
